import React, { useState } from "react";
import { styled } from "@linaria/react";
import ListWithTitle from "@pages/ShieldStarter/Components/ListWithTitle";
import Link from "@components/_Revamp/Link";
import { useAvivaSelector } from "@redux/hook";
import ErrorModal from "@pages/ShieldStarter/Components/Modals/ErrorModal";
import { Text } from "@pages/ShieldStarter/Components/Text";
import Icon from "@components/_Revamp/Icon";

const Wrap = styled.div`
  max-width: 864px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 50px auto auto;
  flex-direction: column;
  flex-wrap: wrap;
  border-bottom: 1px solid #d8d8d8;
  @media screen and (max-width: 588px) {
    max-width: 580px;
    padding: 0px;
  }
`;

function ChildInfo(props: any) {
  const { items } = props;
  const openChildItem = useAvivaSelector(
    (state) => state.shieldStarterStep3.openChildItem
  );
  const personalChildInfo: any = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalChildInfo
  );
  const [noChildClick, setNoChildClick] = useState<boolean>(false);

  return (
    <>
      <Wrap>
        <Text variant="title" fontSize="28px" fontWeight={600}>
          Your Child&apos;s Details
        </Text>
        <Text
          variant="base"
          fontSize="14px"
          fontWeight={600}
          color={"#8A8988"}
        > 
          {
            items?.availToPurch?.childDataList.length > 1
            ? "You can only purchase for 1 child at a time. To purchase for another child, please start a new application."
            : "Select child (if eligible) or tap the status for more details."
          }
        </Text>
        <ListWithTitle
          title={"Eligible to buy"}
          toolTip={null}
          items={items?.availToPurch?.childDataList || null}
          isCheckable={true}
          bcolor="#00AC95"
          infoType="child"
          openChildItem={openChildItem}
          itemType="availToPurch"
          personalChildInfo={personalChildInfo}
        />

        {items?.purchThroMyself?.childDataList && (
          <ListWithTitle
            title={"Buy via ‘Myself’"}
            toolTip={
              'Your child who is aged 16 and above must select the "Myself" option to buy'
            }
            items={items?.purchThroMyself.childDataList || null}
            restartJourney={true}
            bcolor="#00AC95"
            infoType="child"
            openChildItem={openChildItem}
          />
        )}

        {items?.existingShieldPlan?.childDataList && (
          <ListWithTitle
            title={"Existing Singlife Shield policy"}
            toolTip="Your child already has a Singlife Shield policy. Contact your financial adviser representative if you want to change policies."
            items={items?.existingShieldPlan?.childDataList}
            infoType="child"
            openChildItem={openChildItem}
          />
        )}

        {items?.doesNotQualifProd?.childDataList && (
          <ListWithTitle
            title={"Not eligible to buy"}
            toolTip="As this product may not be suitable for your child, please contact your financial adviser representative for further assistance"
            items={items?.doesNotQualifProd?.childDataList}
            infoType="child"
            openChildItem={openChildItem}
          />
        )}

        {items?.policyAppInProcess?.childDataList && (
          <ListWithTitle
            title={"Application being processed"}
            toolTip="You may have bought a Singlife Shield policy recently and the application is still being processed"
            items={items?.policyAppInProcess?.childDataList || null}
            infoType="child"
            openChildItem={openChildItem}
          />
        )}

        <div
          style={{
            margin: "56px 0",
            display: "flex",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Link
            color="#883E89"
            underline={false}
            slotIcon="end"
            fontSize={18}
            fontWeight={600}
            text={`Can't see your child's details?`}
            variant="button"
            onClick={() => {
              setNoChildClick(true);
            }}
          />
          <div style={{marginRight:'28px'}}/> <Icon name="chevron-right-purple"  />
        </div>
      </Wrap>
      {noChildClick && (
        <ErrorModal
          error="You may wish to contact our Financial Adviser Representative for assistance."
          title="Can’t find your child’s details?"
          onCloseFn={() => setNoChildClick(false)}
        />
      )}
    </>
  );
}
export default ChildInfo;
